// extracted by mini-css-extract-plugin
module.exports = {"CustomRandy":"CustomRandy_CustomRandy__3DAlG","ContentContainer":"CustomRandy_ContentContainer__1JGOS"};